module.exports = __webpack_public_path__ + "static/AAA-10901-60a08256df609b7bb44721253c711900.png";